/**
 * Constants pulled from this file
 * wdpr-ui-angular-mapplication/src/map/mapplication-defaults.factory.js
 */
import { CRS } from 'leaflet';

export const FINDER_MAP_DEFAULT_URL = 'https://stage.cdn6.parksmedia.wdprapps.disney.com';

const WDPRO_MEDIA_CDN1 = 'https://secure.cdn1.wdpromedia.com/media/pep';
const WDPRO_MEDIA_CDN3 = 'https://secure.cdn3.wdpromedia.com/media/pep';
const WDPRO_MEDIA_CDN4 = 'https://secure.cdn4.wdpromedia.com/media/pep';
const MAP_PIN_CDN = 'https://secure.cdn1.wdpromedia.com/dam/global/pins';

const WDPRO_LE_MEDIA_CDN1 = 'https://cdn1.wdpromedia-le.disney.go.com/media/pep';

const LIVE_MEDIA = 'live/media/modules/maps/img/content/pins';
const PIPELINE_MEDIA = 'pipeline/media/modules/maps/img/content/pins';

const SHADOW = {
    iconUrl: `${WDPRO_MEDIA_CDN3}/${LIVE_MEDIA}/2b12f820ab97f2cf4e849f4c56c3b06f-shadow.png`,
    iconSize: [26, 11],
    shadowAnchor: [-2, -5]
};

const MAP_FILE = '{version}/{z}/{x}/{y}';
const MAP_PATH = '/media/maps/prod';

export const MAP_TYPES = {
    LEAFLET: 'leaflet'
};

export const MAP_POPUP = {
    maxWidth: 300,
    maxHeight: 300,
    autoPanPadding: [50, 50],
    debounceTime: 500
};

export const MAP_DEFAULT_ID = 'finder-map-container';

export const FINDER_MAP_BASE = {
    mapType: MAP_TYPES.LEAFLET,
    maxZoom: 20,
    keyboard: true,
    dragging: true,
    worldCopyJump: false,
    doubleClickZoom: true,
    scrollWheelZoom: false,
    touchZoom: true,
    zoomControl: false, // This needs to be false so it can be moved later
    addZoomControl: true, // This is a flag used so I can manually add the zoom controls to the right location
    zoomSliderControl: false,
    preferCanvas: true, // Force the map to draw paths on a canvas instead of using SVG
    zoomOptions: {
        position: 'topright',
    },
    attributionControl: false,
    tileLayer: '',
    tileLayerOptions: { maxZoom: 20 },
    controls: {
        layers: {
            visible: true,
            position: 'topright',
            collapsed: false
        }
    },
    maxBounds: {
        southWest: {
            lat: 0,
            lng: 0
        },
        northEast: {
            lat: 0,
            lng: 0
        }
    },
    crs: CRS.EPSG3857,
    path: {
        weight: 4,
        opacity: 1,
        color: '#0093DA'
    },
    center: {
        lat: 0,
        lng: 0,
        zoom: 14
    },
    popup: {
        offset: [0, 20]
    },
    zoomSnap: 0.1
};

/**
 * @description Return map defaults per brand.
 * @param cdnPath Base URL.
 * @returns
 */
export const finderMapSites = (cdnPath) => ({
    wdw: {
        tileLayer: `${cdnPath}${MAP_PATH}/${MAP_FILE}.jpg`,
        tileLayerOptions: {
            maxZoom: 20,
            minZoom: 11,
            version: 47,
        },
        center: {
            lat: 28.382446,
            lng: -81.56143,
            zoom: 12
        },
        maxBounds: {
            southWest: {
                lat: 28.26598,
                lng: -81.89827
            },
            northEast: {
                lat: 28.535,
                lng: -81.255
            }
        }
    },
    dlr: {
        tileLayer: `${cdnPath}${MAP_PATH}/disneyland/${MAP_FILE}.jpg`,
        tileLayerOptions: {
            maxZoom: 20,
            minZoom: 14,
            version: 5.1,
        },
        center: {
            lat: 33.811,
            lng: -117.922,
            zoom: 14
        },
        maxBounds: {
            southWest: {
                lat: 33.75,
                lng: -118.5
            },
            northEast: {
                lat: 33.95,
                lng: -117
            }
        }
    },
    hkdl: {
        tileLayer: `${cdnPath}${MAP_PATH}/hkdl/${MAP_FILE}.jpg`,
        tileLayerOptions: {
            maxZoom: 20,
            minZoom: 11,
            version: 2,
        },
        center: {
            lat: 22.313250,
            lng: 114.041282,
            zoom: 12
        },
        maxBounds: {
            southWest: {
                lat: 22.294718,
                lng: 113.971609
            },
            northEast: {
                lat: 22.354107,
                lng: 114.069456
            }
        }
    }
});

export const MARKER_CLUSTER_OPTIONS = {
    showCoverageOnHover: false,
    spiderfyOnMaxZoom: true,
    maxClusterRadius: 40,
    spiderLegPolylineOptions: { opacity: 1, weight: 1.5, color: '#222' }
};

export const MARKER_TYPES = {
    DEFAULT: {
        iconUrl: `${WDPRO_MEDIA_CDN1}/${LIVE_MEDIA}/b08d2e698adc28221b7b4e5f3886fada-default.png`,
        iconSize: [25, 39],
        shadowUrl: SHADOW.iconUrl,
        shadowSize: SHADOW.iconSize,
        shadowAnchor: SHADOW.shadowAnchor,
        className: 'default'
    },
    ITINERARY: {
        iconUrl: `${WDPRO_MEDIA_CDN4}/${LIVE_MEDIA}/939d0ebe03b349cc7301a551b72b5129-itinerary.png`,
        iconSize: [39, 51],
        iconAnchor: [18, 50],
        shadowUrl: SHADOW.iconUrl,
        shadowSize: SHADOW.iconSize,
        popupAnchor: [0, -40],
        className: 'itinerary'
    },
    UNAVAILABLE: {
        iconUrl: `${WDPRO_MEDIA_CDN1}/${LIVE_MEDIA}/8194e09e2eef1723b0b5e6f3a9ddbf77-unavailable.png`,
        iconSize: [25, 39],
        shadowUrl: SHADOW.iconUrl,
        shadowSize: SHADOW.iconSize,
        className: 'default'
    },
    HOVER: {
        iconUrl: `${WDPRO_MEDIA_CDN1}/${LIVE_MEDIA}/8194e09e2eef1723b0b5e6f3a9ddbf77-unavailable.png`,
        iconSize: [25, 39],
        shadowUrl: SHADOW.iconUrl,
        shadowSize: SHADOW.iconSize,
        shadowAnchor: SHADOW.shadowAnchor,
        className: 'mouse-over'
    },
    REFURBISHMENT: {
        iconUrl: `${WDPRO_MEDIA_CDN4}/${PIPELINE_MEDIA}/8194e09e2eef1723b0b5e6f3a9ddbf77-unavailable.png`,
        iconSize: [25, 39],
        shadowUrl: SHADOW.iconUrl,
        shadowSize: SHADOW.iconSize,
        className: 'default'
    },
    PHOTOPASS: {
        iconUrl: `${WDPRO_LE_MEDIA_CDN1}/${PIPELINE_MEDIA}/6b25ed95bc7382e73cb4dbea807bc79b-photo_pass.png`,
        iconSize: [25, 39],
        shadowUrl: SHADOW.iconUrl,
        shadowSize: SHADOW.iconSize,
        className: 'intinerary photopass'
    },
    GXP: {
        iconUrl: `${WDPRO_LE_MEDIA_CDN1}/${PIPELINE_MEDIA}/c90c32c1ade222a0e7084fe414067670-gxp.png`,
        iconSize: [25, 39],
        shadowUrl: SHADOW.iconUrl,
        shadowSize: SHADOW.iconSize,
        className: 'default'
    },
    MAGIC_PASS: {
        iconUrl: `${WDPRO_LE_MEDIA_CDN1}/${PIPELINE_MEDIA}/178fb5c78c71c93c65b8d8ac67d9396d-magic_pass.png`,
        iconSize: [25, 39],
        shadowUrl: SHADOW.iconUrl,
        shadowSize: SHADOW.iconSize,
        className: 'itinerary'
    },
    CLUSTER_SMALL: {
        iconUrl: `${WDPRO_LE_MEDIA_CDN1}/${PIPELINE_MEDIA}/5e3d6e3298d2e685f2d11e0c8dc16523-cluster_small.png`,
        iconSize: [25, 25],
        className: 'cluster'
    },
    CLUSTER_WIDE: {
        iconUrl: `${WDPRO_LE_MEDIA_CDN1}/${PIPELINE_MEDIA}/a29a6d6d82d950595885a297567f668c-cluster_wide.png`,
        iconSize: [32, 25],
        className: 'cluster'
    },
    CLUSTER_UNAVAILABLE_SMALL: {
        iconUrl: `${WDPRO_LE_MEDIA_CDN1}/${PIPELINE_MEDIA}/5f465002ede74a007291f65492ff6279-cluster_small_unavailable.png`,
        iconSize: [25, 25],
        className: 'cluster'
    },
    CLUSTER_UNAVAILABLE_WIDE: {
        iconUrl: `${WDPRO_LE_MEDIA_CDN1}/${PIPELINE_MEDIA}/9a5844420b10b24d1ee1e06997ddcf3f-cluster_wide_unavailable.png`,
        iconSize: [32, 25],
        className: 'cluster'
    }
};

// Populate the marker constant with the new markers
[
    'thrill',
    'shows',
    'fireworks',
    'characters',
    'parades',
    'water-rides',
    'exhibits',
    'games',
    'play-areas',
    'live-music',
    'activities',
    'dine',
    'info',
    'shop'
].forEach(pinType => {
    MARKER_TYPES[pinType] = {
        iconUrl: `${MAP_PIN_CDN}/${pinType}-{type}.svg`,
        iconSize: [60, 74],
        shadowUrl: SHADOW.iconUrl,
        shadowSize: SHADOW.iconSize,
        shadowAnchor: SHADOW.shadowAnchor,
        className: pinType
    };
});
